import { IAddressInfoSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

export function getFullAddressFromGeo(addresses: IAddressInfoSchema[]): string {
  return addresses.map(addr => addr.shortName).join(', ');
}
